module.exports = __webpack_public_path__ + "696459054b06b83e71fff69d9154242f.png";